var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lists"},[_c('h3',[_vm._v("图文列表卡片")]),_vm._v(" "),_c('pic-list')],1)}
var staticRenderFns = []
export { render, staticRenderFns }